/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function () {
        // JavaScript to be fired on all pages




      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired

        $(window).load(function(){

        $('.featured-image .bg-masked').css('opacity', .5);

        });
        function spacerREM() {


          if ($('.wp-block-spacer').length) {

            $('.wp-block-spacer').each(function () {

              var height = $(this).outerHeight();
              var classes = $(this).attr('class');

              console.log(height);

              var converted = height / 16;

              $(this).attr('style', 'height: ' + converted + 'rem;').addClass(classes);

            });
          }
        }

        function imgWidth() {



          if ($('.alignfull, .alignwide, .alignleft, .alignright').length) {
            var editor = $('.editor');

            editor.attr('style', '--colOffset: ' + (editor.offset().left + 15) + 'px; --editorWidth: ' + editor.width() + 'px');

          }

        }

        imgWidth();
        spacerREM();

        var resizeTimer;

        $(window).on('resize', function (e) {

          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function () {

            imgWidth();
            //            editor.attr('style', '--width: ' + (editor.offset().left + 15) + 'px');

          }, 500);

        });

        $('.gfield_label').not('.gfield_label_before_complex').each(function () {
          var label = $(this).html();
          var inputfor = $(this).attr('for');

          $('#' + inputfor + '').after('<label class="gfield_label below dynamic">' + label + '</label>');
        });


      }
    }, // Home page
    'home': {
      init: function () {
        // JavaScript to be fired on the home page


      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
        var vid = document.getElementById("network");

        function playVid() {

        }

        var waypoints = $('#coverage').waypoint({
          handler: function (direction) {
            var map = $('.nationwide-coverage-spiral');
            if ($('#coverage').hasClass('playing')) {

            } else {

              vid.play();
              $('#coverage').addClass('playing');

            }
          },
          offset: '50%'
        })

      }
    }, // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function () {
        // JavaScript to be fired on the about us page
      }
    }
  };
  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';
      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');
      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });
      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };
  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
